import { useRequestGenerateLeftEarExaminationVideoMutation } from './hooks/useRequestGenerateLeftEarExaminationVideoMutation';
import { RequestGenerateVisualExaminationVideoButtonProps } from 'pages/ExaminationPage/components/RequestGenerateVisualExaminationVideoButton/RequestGenerateVisualExaminationVideoButtonProps';
import { FC } from 'react';

export const RequestGenerateLeftEarExaminationVideoButton: FC<RequestGenerateVisualExaminationVideoButtonProps> =
  ({ examinationId }) => {
    const { mutate, isSuccess } =
      useRequestGenerateLeftEarExaminationVideoMutation();

    return (
      <div
        style={{ width: '100%', height: '100%', lineHeight: '35px' }}
        onClick={() => (!isSuccess ? mutate(examinationId) : null)}
      >
        Full video
      </div>
    );
  };
